<div class="case-table table-responsive thead_less_table">
    <div class="row">
        <div class="col-md-12">
          <table class="neu-table table table-striped neu-table w-100 " datatable [dtOptions]="dtOptions"></table>
        </div>
      </div>
</div>
<button class="btn btn-lg bg-blue text-white  float-right mb-3" [routerLink]="['../notes']">
    View all notes <i class="align-middle fas fa-angle-right"></i>
</button>